import { alpha, makeStyles } from '@material-ui/core';

export default makeStyles(({ palette }) => ({
  root: {
    fontFamily: 'Quicksand, sans-serif',
    fontSize: '14px',
    fontWeight: 'bold',
    lineHeight: '18px',
  },
  root__success: {
    backgroundColor: alpha(palette.success.main, 0.8),
    color: palette.success.contrastText,
  },
  root__info: {
    backgroundColor: alpha(palette.info.main, 0.8),
    color: palette.info.contrastText,
  },
  root__warning: {
    backgroundColor: alpha(palette.warning.main, 0.8),
    color: palette.warning.contrastText,
  },
  root__error: {
    backgroundColor: alpha(palette.error.main, 0.8),
    color: palette.error.contrastText,
  },
}));
